import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ChangeDetectionStrategy } from '@angular/core';
import { SafeHtml } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { NotificationView } from '@api-proxies';
import { NotificationService } from '@http/clients/notification.service';
import { EntityTypes } from '@models/enums/EntityTypes';
import { NotificationTypes } from '@models/enums/NotificationTypes';
import { DateTimeService, IconSanitizerService } from 'ngx-lib';

interface IEntity {
    route: string;
}

@Component({
    selector: 'app-notification-item',
    templateUrl: './notification-item.component.html',
    styleUrls: ['./notification-item.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [CommonModule, RouterModule]
})
export class NotificationItemComponent implements OnInit {
    @Input()
    notification?: NotificationView;

    @Output()
    notificationChange: EventEmitter<void>;

    @Input()
    isPanel?: boolean;

    svg?: SafeHtml;

    timeAgoDate?: string | null;

    entities: Record<number, IEntity>;

    url?: string;

    constructor(
        private readonly notificationService: NotificationService,
        private readonly dateTimeService: DateTimeService,
        private readonly iconSanitizer: IconSanitizerService
    ) {
        this.notificationChange = new EventEmitter<void>();
        this.isPanel = false;

        this.entities = {
            [EntityTypes.Company]: {
                route: '/companies-single/'
            },
            [EntityTypes.Contact]: {
                route: '/contacts-single/'
            },
            [EntityTypes.Building]: {
                route: '/buildings-single/'
            },
            [EntityTypes.Opportunity]: {
                route: '/opportunities-single/'
            },
            [EntityTypes.Account]: {
                route: '/accounts-single/'
            }
        };
    }

    ngOnInit(): void {
        this.svg = this.getIcon(this.notification?.notificationTypeId);
        this.url = this.getUrl();
        if (this.notification) {
            this.timeAgoDate = this.getTimeAgo(this.notification.notificationDate);
        }
    }

    async onClick(id: number): Promise<void> {
        if (!this.notification?.isRead) {
            await this.notificationService.markAsRead(id);
            if (this.notification) this.notification.isRead = true;
            this.notificationChange.emit();
        }
    }

    private getTimeAgo(notificationDate: Date): string | null {
        return this.dateTimeService.getTimeAgo(notificationDate);
    }

    private getIcon(id?: NotificationTypes): SafeHtml {
        let iconName: SafeHtml;
        switch (id) {
            case NotificationTypes.NoteMention:
                iconName = this.iconSanitizer.getIcon('note');
                break;

            case NotificationTypes.OpportunityAssignment:
            case NotificationTypes.OpportunityBidStatusChange:
            case NotificationTypes.OpportunityStatusChange:
            case NotificationTypes.ExpiringDueDate:
            case NotificationTypes.ExpiringFollowUpContactDate:
                iconName = this.iconSanitizer.getIcon('opportunities');
                break;

            default:
                iconName = this.iconSanitizer.getIcon('note');
                break;
        }

        return iconName;
    }

    private getUrl(): string | undefined {
        if (this.notification) {
            return this.entities[this.notification.entityTypeId]?.route + this.notification.entityId + '/Overview';
        }
        return undefined;
    }

    handleMouseClick(event: MouseEvent, id: number): void {
        if (event.button === 1 || event.button === 2) {
            this.onClick(id);
        }
    }
}
